import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";
import { Plug, Zap, Database, MessageSquare } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const IntegrationenHero = () => {
  const { t, localizePath } = useLanguage();

  return (
    <section className="relative pt-36 md:pt-48 pb-16 md:pb-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-secondary/30" />

      <div className="absolute top-24 left-[10%] animate-bounce" style={{ animationDelay: "0s", animationDuration: "3s" }}>
        <div className="w-14 h-14 rounded-2xl bg-chathero-mint/20 flex items-center justify-center">
          <Plug className="w-7 h-7 text-chathero-mint" />
        </div>
      </div>
      <div className="absolute top-32 right-[15%] animate-bounce" style={{ animationDelay: "0.5s", animationDuration: "3.5s" }}>
        <div className="w-12 h-12 rounded-2xl bg-chathero-orange/20 flex items-center justify-center">
          <Zap className="w-6 h-6 text-chathero-orange" />
        </div>
      </div>
      <div className="absolute bottom-32 left-[20%] animate-bounce" style={{ animationDelay: "1s", animationDuration: "4s" }}>
        <div className="w-10 h-10 rounded-2xl bg-primary/20 flex items-center justify-center">
          <Database className="w-5 h-5 text-primary" />
        </div>
      </div>
      <div className="absolute bottom-24 right-[10%] animate-bounce" style={{ animationDelay: "1.5s", animationDuration: "3.2s" }}>
        <div className="w-11 h-11 rounded-2xl bg-chathero-mint/20 flex items-center justify-center">
          <MessageSquare className="w-5 h-5 text-chathero-mint" />
        </div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={localizePath("/")} className="text-muted-foreground hover:text-primary">
                  {t("integrationenPage.hero.breadcrumbProducts")}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-chathero-mint font-medium">
                {t("integrationenPage.hero.breadcrumbCurrent")}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-primary leading-tight mb-6 animate-fade-in">
            {t("integrationenPage.hero.title")}
          </h1>
          <p className="text-xl md:text-2xl text-chathero-mint font-semibold mb-6 animate-fade-in" style={{ animationDelay: "0.1s" }}>
            {t("integrationenPage.hero.subtitle")}
          </p>
          <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-3xl mx-auto animate-fade-in" style={{ animationDelay: "0.2s" }}>
            {t("integrationenPage.hero.description")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default IntegrationenHero;
